import { ShellFrame, type AppShellProps } from "./ShellFrame";

export function FormShell(props: AppShellProps) {
  return <ShellFrame {...props} routeSurface="form" />;
}
